import { scrollToId } from "./helpers";
import { useI18n } from "./i18n";

export default function Footer() {
  const { t } = useI18n();

  return (
    <footer className="mt-10 pb-10">
      <div className="mx-auto max-w-6xl px-4">
        <div className="rounded-3xl border border-theme-border bg-theme-surface backdrop-blur-sm p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="text-xs tracking-[0.25em] uppercase text-theme-text-faint">{t("footer.thank_you")}</p>
            <p className="mt-2 font-serif text-2xl">{t("footer.waiting")}</p>
          </div>
          <button
            onClick={() => scrollToId("envelope-hero")}
            className="rounded-full border border-theme-border-subtle bg-theme-surface px-5 py-2.5 text-sm text-theme-text-muted hover:bg-theme-surface-hover transition"
          >
            {t("footer.back_to_top")}
          </button>
        </div>

        <p className="mt-6 text-center text-xs text-theme-text-faint">
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </p>
      </div>
    </footer>
  );
}
